export const renderAdditionalContent = (contentList, threshold, className = '', additionalText = '') => {
  return [
    ...contentList.slice(0, threshold),
    <div key="more" className={className}>
      + {contentList.length - threshold} {additionalText}
    </div>
  ];
};
